import { Component } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ContractDetails } from '../../lib/models/contracts';
import { DashboardService } from '../../lib/services/dashboard/dashboard.service';
import { LoadingService } from '../../lib/services/loading/loading.service';

@Component({
  selector: 'app-contract-information-modal',
  templateUrl: './contract-information-modal.component.html',
  styleUrls: ['./contract-information-modal.component.scss']
})
export class ContractInformationModalComponent {
  modalRef!: NgbModalRef;
  contractDetails!: ContractDetails
  contractId: string | number = ""
  idReferenceContract: string | number = ""

  constructor(
    private dashboardService: DashboardService,
    private loadingService: LoadingService
  ) { }

  closeDialog() {
    this.modalRef.close()
  }

  download(event: any) {
    this.loadingService.show()
    this.dashboardService.downloadContractReport(this.contractId).subscribe({
      next: pedBytes => {
        this.loadingService.hide()
        const downloadURL = window.URL.createObjectURL(pedBytes);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${this.contractId}.pdf`;
        link.click();
      },
      error: error => {
        this.loadingService.hide()
        console.log(error)
      }
    })
  }

  downloadPDFdeposits(event: any) {
    this.loadingService.show()
    this.dashboardService.downloadPDFdesposits(this.contractId, this.idReferenceContract).subscribe({
      next: pedBytes => {
        this.loadingService.hide()
        const downloadURL = window.URL.createObjectURL(pedBytes);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = `Como-recibir-depositos-${this.idReferenceContract}.pdf`;
        link.click();
      },
      error: error => {
        this.loadingService.hide()
        console.log(error)
      }
    })
  }
}
